import request from '@/utils/request';
import { isPhoneNumber } from '@/utils/index';
import qs from 'qs';

// 与小程序共用专属导购接口
export const getSgStaffList = () => request({ url: '/admin/user-detail/getSgStaffList', method: 'get' });
export const updateSgStaff = (data) => request({ url: '/admin/user-detail/updateSgStaff', method: 'post', data });

// 登录
export function login(data) {
  return request({
    url: '/doLogin?userName=' + data.username + '&passWord=' + data.password + '&captcha=' + data.code,
    method: 'POST',
    params: {},
  });
}
export const loginByUsername = (params, code, randomStr) => {
  let grant_type = 'password';
  let dataObj = qs.stringify(params);
  return request({
    // baseURL: process.env.VUE_APP_WT_API, //登录接口单独的端口
    url: '/auth/oauth/token',
    headers: {
      isToken: false,
      'TENANT-ID': '1',
      Authorization: isPhoneNumber(params.username) === true ? 'Basic YWRtaW46YWRtaW4=' : 'Basic cGlnOnBpZw==',
    },
    method: 'post',
    params: { randomStr, code, grant_type },
    data: dataObj,
  });
};
// 获取权限
export const getRole = () => {
  return request({
    url: '/exhibition/role',
    method: 'get',
    ignoreCode: true,
  });
};
// 判断是年轻空间还是周六福
export const getType = () => {
  return request({
    url: '/exhibition/dic/type/exhibition_tenant_id',
    method: 'get',
  });
};
// 判断有没有标配九华系列
export const getStandard = (orgCode) => {
  return request({
    url: `/exhibition/product/getPropGroupFull/${orgCode}`,
    method: 'get',
  });
};
// 云平台跳转过来获取用户信息
export const getHallInfo = () => {
  return request({
    url: '/exhibition/user',
    method: 'get',
  });
};
// 退出登录
export const logout = () => {
  return request({
    // baseURL: process.env.VUE_APP_WT_API, //登录接口单独的端口
    url: '/auth/token/logout',
    method: 'delete',
  });
};

// pos登录页接口
export function posLogin(data) {
  return request({
    url: '/posLogin?token=' + data,
    method: 'POST',
    params: {},
  });
}
export const getUserInfo = () => {
  return request({
    url: '/admin/user/info',
    method: 'get',
  });
};
export const getRtjGoldPrice = () => {
  return request({
    url: '/exhibition/getRtjGoldPrice',
    method: 'get',
  });
};
// 埋点
export const trackingTags = (data) => {
  return request({
    url: `/exhibition/report/addClick?entrance=${data.entrance}&platform=pc`,
    method: 'POST',
  });
};
